import { FC } from 'react';
import { SidebarTabLayout } from '../shared/SidebarTabLayout';
import { Button, Icon, TimeAgo } from '../../../../../shared/ui';
import { IconMap } from '../../../../../shared/sprite';
import { VideoRecordType } from '@distribute/shared/api-types/video-record';
import {
  DEFAULT_RATIO,
  getMuxImage,
  getMuxStream,
} from '@distribute/shared/utils';
import { VideoPlayer } from '../../../../../entities/video';

import {
  checkIsRecordConverting,
  checkIsRecordConvertingFailed,
} from '../../../../../features/recordings/lib';

type Props = {
  record: VideoRecordType;
  onInsert: (record: VideoRecordType) => void;
  closePreview: () => void;
};

export const RecordPreview: FC<Props> = ({
  record,
  closePreview,
  onInsert,
}) => {
  return (
    <SidebarTabLayout
      headerComponent={
        <div className="flex items-center justify-between">
          <Button
            size="md"
            color="secondary"
            variant="icon"
            onClick={closePreview}
          >
            <Icon glyph={IconMap.ArrowLeft} width={20} />
          </Button>
          <Button
            size="md"
            color="primary"
            variant="text"
            onClick={() => onInsert(record)}
          >
            Insert Video
          </Button>
        </div>
      }
    >
      <p className="text-2xl font-semibold text-gray-900 truncate mb-1">
        {record.name}
      </p>
      <p className="text-sm text-gray-600 mb-4">
        <TimeAgo datetime={record.createdAt} locale="my" />
      </p>
      <VideoPlayer
        isFailed={checkIsRecordConvertingFailed({
          status: record.status,
          statusConvert: record.statusConvert,
        })}
        isLoading={checkIsRecordConverting(record.statusConvert)}
        url={getMuxStream(record.playbackId || '')}
        aspectRatio={record.metadata?.mux?.aspectRatio || DEFAULT_RATIO}
        posterUrl={getMuxImage(record.playbackId || '')}
      />
    </SidebarTabLayout>
  );
};
